import { useContext } from 'react';
import { MdEmail, MdOutlineWhatsapp } from 'react-icons/md';
import { AppContext } from '../App';
import { contactDetails } from '../HospiumContent';
import { getCurrentYear } from '../Helpers';
import logoWorded from '../assets/logo_worded.png';

export default function Footer() {
  const appContext = useContext(AppContext);
  const goTo = (item) => appContext.navTo({ item });
  return (
    <footer className="HospiumFooter"><div className="container">
      <div className="HospiumFooterGrid">
        <div className="HospiumFooterBrand"><img src={logoWorded} alt="Hospium" /><p><strong>Smarter Care, Better Outcomes.</strong><br />Digital healthcare products for hospitals, pharmacies, care teams, and patients.</p></div>
        <div><h3>Explore</h3><button onClick={() => goTo('services')}>Products & Services</button><button onClick={() => goTo('projects')}>Our Clients</button><button onClick={() => goTo('contact_us')}>Place Inquiry</button></div>
        <div><h3>Products</h3><span>Hospium Core</span><span>Hospium ID</span><span>Hospium Self Care</span><span>Hospium Pharma</span></div>
        <div><h3>Contact</h3><a href={contactDetails.whatsappUrl} target="_blank" rel="noreferrer"><MdOutlineWhatsapp /> {contactDetails.whatsappDisplay}</a><a href={`mailto:${contactDetails.email}`}><MdEmail /> {contactDetails.email}</a></div>
      </div>
      <div className="HospiumFooterBottom"><span>&copy; {getCurrentYear()} Hospium. All rights reserved.</span><span>Built for better healthcare operations.</span></div>
    </div></footer>
  );
}
